module.exports = __webpack_public_path__ + "static/img/default.210edea7.jpg";